import React, { useEffect, useState } from "react";

export default function Funcionalidad({ setF, filtroIcon, funcion, cambio }) {
  const [itemSel, setItemSel] = useState(null)

  useEffect(() => { setItemSel(null) })

  return (
    <div style={{ marginTop: "10px", textAlign: "center" }}>
      <img
        id={`FU${funcion}`}
        src={filtroIcon}
        alt="?"
        height="20px"
        width="20px"
        style={Sicon}
        title={funcion}
        onMouseOver={(e) => {
          //    console.log(itemSel, e.currentTarget, funcion, 'over')
          if (itemSel !== e.currentTarget) {
            e.currentTarget.style.transform = "scale(1.5)";
            e.currentTarget.style.opacity = 1;
          }
        }}
        onMouseLeave={(e) => {
          //   console.log(itemSel, e.currentTarget, funcion, 'leave')
          if (itemSel !== e.currentTarget) {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.opacity = 0.5;
          }
        }}
        onClick={(e) => {
          setF(funcion)
          if (itemSel !== e.currentTarget) {
            //      console.log(itemSel, e.currentTarget, funcion)
            e.currentTarget.style.transform = "scale(1.5)";
            e.currentTarget.style.opacity = 1;
            if (itemSel) {
              itemSel.style.transform = "";
              itemSel.style.opacity = 0.5;
            }
            setItemSel(e.currentTarget)
          }
        }}
      />
    </div>
  );
}

const Sicon = {
  cursor: "pointer",
  opacity: 0.5,
  //  background: "black"
};
